export const API_ROOT_URL = process.env.REACT_APP_API_ENDPOINT;
export const AUTH_URL = process.env.REACT_APP_AUTH_ENDPOINT;
export const REQUEST_TIMEOUT = 25 * 1000;
export const UPLOAD_TIMEOUT = 150 * 1000;
export const KIBANA_ENDPOINT = "https://analytics.chatbots.a2d24.com"
export const MAX_SURVEY_QUESTIONS = 9
